import { render, staticRenderFns } from "./contractPay.vue?vue&type=template&id=dd789470&scoped=true"
import script from "./contractPay.vue?vue&type=script&lang=js"
export * from "./contractPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd789470",
  null
  
)

export default component.exports